import {keepPreviousData, queryOptions, useQuery} from "@tanstack/react-query";

import * as apiClient from "@/lib/api";
import {useQueryResetWithRefresh} from "@/lib/hooks/query-refetch-with-reset";
import {buildQueryParamsStringWithFilters} from "@/lib/utils";
import {InviteRequestData, InviteRequestsApiResponse} from "@/modules/invite-feedback/requests/types";
import {FetchParams} from "@/types/search";
import {QUERY_KEY_INVITE_REQUESTS} from "@/utils/keys";

export function fetchCsvDownloadData(fetchParams: FetchParams): Promise<InviteRequestData[]> {
  return apiClient.get(`/firm/review-invitation-requests/csv?${buildQueryParamsStringWithFilters(fetchParams, {to: undefined, from: undefined}, null)}`, false)
}

function fetchInviteRequestsData(fetchParams: FetchParams): Promise<InviteRequestsApiResponse> {
  return apiClient.get(`/firm/review-invitation-requests?${buildQueryParamsStringWithFilters(fetchParams, {to: undefined, from: undefined}, null)}`, true)
}

export const inviteRequestsQueryOptions = (
  fetchParams: FetchParams
) =>
  queryOptions({
    queryKey: [QUERY_KEY_INVITE_REQUESTS, fetchParams],
    queryFn: () => fetchInviteRequestsData(fetchParams),
    placeholderData: keepPreviousData
  });

export const useInviteRequests = (fetchParams: FetchParams) => {
  const queryOptions = inviteRequestsQueryOptions(fetchParams)
  const query = useQuery(queryOptions)
  const { resetAndRefetch } = useQueryResetWithRefresh(queryOptions.queryKey, query.refetch)

  return {
    data: query.data?.data ?? [],
    total: query.data?.aggregate_data?.total ?? 0,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isPlaceholderData: query.isPlaceholderData,
    isError: query.isError,
    isRefetchError: query.isRefetchError,
    error: query.error,
    isRefetching: query.isRefetching,
    isSuccess: query.isSuccess,
    status: query.status,
    refetch: resetAndRefetch
  }
}